export default __webpack_public_path__ + "static/media/1999.a9e87307.png";